import { Button, ButtonProps } from '../../../../cdl/Button/Button';
import { translate } from '../../../../common/helpers/translate.helper';
import { IconArrowRight } from '../../../../common/icons/cdl/ArrowRight';

interface ContinueButtonProps extends Omit<ButtonProps, 'TrailingIcon' | 'LeadingIcon' | 'emphasis'> {}

export const ContinueButton = (props: ContinueButtonProps) => {
    return (
        <Button {...props} TrailingIcon={IconArrowRight} emphasis="high">
            {translate('btn.continue')}
        </Button>
    );
};
